import { BRAND } from "@/constants/brand";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={BRAND.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Pop Panda on WhatsApp"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.55)] hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.93 11.93 0 0 0 12.05 0C5.45 0 .1 5.34.1 11.93c0 2.1.55 4.14 1.6 5.94L0 24l6.32-1.66a11.91 11.91 0 0 0 5.72 1.46h.01c6.6 0 11.95-5.35 11.95-11.94 0-3.19-1.24-6.19-3.48-8.38ZM12.05 21.5h-.01a9.55 9.55 0 0 1-4.86-1.33l-.35-.21-3.75.98 1-3.65-.23-.37a9.54 9.54 0 0 1-1.46-5.09c0-5.27 4.29-9.55 9.56-9.55 2.55 0 4.95.99 6.76 2.8a9.5 9.5 0 0 1 2.8 6.75c0 5.27-4.29 9.56-9.56 9.56Zm5.47-7.16c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.95 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48a9 9 0 0 1-1.66-2.07c-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.5.07-.77.37-.27.3-1.02 1-1.02 2.45s1.05 2.85 1.2 3.05c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.67.62.7.22 1.33.19 1.83.12.56-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.08-.12-.27-.2-.57-.35Z" />
      </svg>
      <span className="text-sm font-semibold">WhatsApp</span>
    </a>
  );
}
